const Appeals = () => {

    var amountRemaining = (totalRaised / totalNeeded ) * 100;
    //var raisedToDate = amountRemaining / totalNeeded;
    //var totalRaised = raisedToDate * 100;
    //console.log(amountRemaining);

    document.getElementById("progress-bar").style.width = amountRemaining + "%";

    // var progressBar = document.getElementsByClassName("progress-bar");
    // console.log(progressBar);
    // progressBar.style.width = amountRemaining;

};

export default Appeals;


// WEBPACK FOOTER //
// ./src/js/app/components/Appeals.js